import type { Map } from 'immutable';

import type { User } from 'hb-react/types';

import type { Topic } from '../types';

interface Following {
  user: Map<string, any>;
}

interface FollowingsState {
  followings: Map<string, Following>;
}

interface GetGroupHeaderMembersProperties {
  currentStateFollowings: Map<string, any> & FollowingsState;
  currentUser: User;
  topic: Topic;
}

export const getGroupHeaderMembers = ({
  currentStateFollowings,
  currentUser,
  topic,
}: GetGroupHeaderMembersProperties) => {
  if (currentUser && topic.followings) {
    return topic.followings.reduce((res: User[], id) => {
      const user = currentStateFollowings
        .getIn(['followings', id.toString()])
        ?.get('user');

      if (user) {
        res.push(user.toJS());
      }

      return res;
    }, [] as User[]);
  }

  return undefined;
};
